
import { Component, Prop, Vue } from "vue-property-decorator";
import BuroPicker from "@/components/pickers/BuroPicker.vue";

@Component({ components: { BuroPicker } })
export default class PasifPersonelDialog extends Vue {
  /** Hangi büronun pasif personeli listelensin (verilmezse tüm tenant). */
  @Prop({}) buroId!: number | string | null;

  show: boolean = false;
  loading: boolean = false;
  items: Array<any> = [];
  activatingId: number | null = null;

  // NOT: Tüm kolonlar `sortable: false`. Sıralanabilir başlıklarda Vuetify, fareyle
  // üzerine gelindiğinde sıralama okunu gösterip başlık metnini yana itiyor; kısa
  // bir listede gereksiz olan bu davranış tabloda kaymaya yol açıyordu.
  // Genişlikler sabitlenerek satırlar arası hizalama da garantiye alındı.
  // Genişlik/oran verilmez (Banka Hesap Bilgileri tablosuyla aynı sade yapı):
  // kolonlar içeriğe göre paylaşılır ve dar ekranda Vuetify kart görünümüne geçer.
  headers = [
    { text: "Adı", value: "ad", align: "start", sortable: false },
    { text: "Pasifleştirme Tarihi", value: "pasif_tarihi", align: "start", sortable: false },
    { text: "Personel Türü", value: "personel_turu", align: "start", sortable: false },
    { text: "Eski Büro", value: "eski_buro_etiketi", align: "start", sortable: false },
    { text: "Pasife Alınma Nedeni", value: "pasif_nedeni_etiketi", align: "start", sortable: false },
    { text: "Mail Adresi", value: "email", align: "start", sortable: false },
    { text: "İşlem", value: "actions", align: "end", sortable: false },
  ];

  /** Backend'den gelen tarihi gg/aa/yyyy olarak biçimler. */
  tarihFormatla(deger: string | null): string {
    if (!deger) return "-";
    const tarih = new Date(String(deger).replace(" ", "T"));
    if (isNaN(tarih.getTime())) return "-";
    const gun = String(tarih.getDate()).padStart(2, "0");
    const ay = String(tarih.getMonth() + 1).padStart(2, "0");
    return `${gun}/${ay}/${tarih.getFullYear()}`;
  }

  // Personel listesiyle aynı seçenekler: 5 / 10 / 15 / Hepsi, varsayılan 5.
  footerProps = {
    "items-per-page-options": [5, 10, 15, -1],
    "items-per-page-all-text": "Hepsi",
    "items-per-page-text": "Sayfa başına satır:",
  };

  // Aktifleştir butonu, pasife alma anından itibaren bekleme süresi (1 saat)
  // dolana kadar pasif kalır. Kalan süre backend'den gelir, canlı azalır.
  kalanSureler: { [key: number]: number } = {};
  private geriSayim: number | null = null;

  mounted() {
    this.geriSayim = window.setInterval(() => {
      let degisti = false;
      Object.keys(this.kalanSureler).forEach((anahtar: any) => {
        if (this.kalanSureler[anahtar] > 0) {
          this.kalanSureler[anahtar] -= 1;
          degisti = true;
        }
      });
      if (degisti) this.kalanSureler = { ...this.kalanSureler };
    }, 1000);
  }

  beforeDestroy() {
    if (this.geriSayim) window.clearInterval(this.geriSayim);
  }

  kalanSaniye(item: any): number {
    return this.kalanSureler[item.id] || 0;
  }

  // Aktifleştirme personel ekleme yetkisiyle geçer (POST personel/{id}/aktiflestir); eski modda master gibi açık.
  get aktiflestirmeYetkili(): boolean {
    return this.$helper.isAuthorizedYeniModda('buro-calisan-bilgisi-ekle');
  }

  aktiflestirTooltip(item: any): string {
    if (!this.aktiflestirmeYetkili) {
      return "Bu işlem için yetkiniz yok.";
    }
    const kalan = this.kalanSaniye(item);
    if (kalan > 0) {
      const dakika = Math.ceil(kalan / 60);
      return `Pasife alındığı için henüz aktifleştirilemez. ${dakika} dk sonra tekrar deneyin.`;
    }
    return "Kullanıcıyı yeniden davet et (davet e-postası gönderilir)";
  }

  open() {
    this.show = true;
    this.load();
  }

  close() {
    this.show = false;
  }

  load() {
    this.loading = true;
    this.$http
      .get("/api/v1/personel/pasif", { params: { buro_id: this.buroId } })
      .then((res: any) => {
        this.items = res.data?.data || res.data || [];
        const harita: { [key: number]: number } = {};
        this.items.forEach((kisi: any) => {
          harita[kisi.id] = Number(kisi.aktiflestirme_kalan_saniye || 0);
        });
        this.kalanSureler = harita;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  /**
   * Bürosu silinmiş kişide hedef büro sorulur; bağı duran kişide sorulmaz
   * (mevcut tek tıklık davranış korunur).
   */
  buroSecimi: any = null;
  secilenBuroId: number | null = null;

  buroSecimiAc(item: any) {
    this.buroSecimi = item;
    this.secilenBuroId = this.buroId ? Number(this.buroId) : null;
  }

  buroSecimiKapat() {
    this.buroSecimi = null;
    this.secilenBuroId = null;
  }

  buroSecerekAktiflestir() {
    if (!this.secilenBuroId || !this.buroSecimi) return;
    const kisi = this.buroSecimi;
    this.buroSecimi = null;
    this.aktiflestir(kisi, this.secilenBuroId);
  }

  aktiflestir(item: any, buroId: number | null = null) {
    if (!this.aktiflestirmeYetkili || this.kalanSaniye(item) > 0 || this.activatingId !== null) return;

    // Bağı kalmayan kişi büro seçilmeden aktifleştirilemez (sunucu 422 döner);
    // kullanıcıyı sunucuya göndermeden önce seçim penceresini aç.
    if (item.buro_secimi_gerekli && !buroId) {
      this.buroSecimiAc(item);
      return;
    }

    this.activatingId = item.id;
    this.$http
      .post("/api/v1/personel/" + item.id + "/aktiflestir", buroId ? { buro_id: buroId } : {})
      .then((res: any) => {
        const veri = res?.data?.data ?? res?.data ?? {};

        // Bekleme süresi dolmamışsa sunucu da engeller; kalan süreyi yansıt.
        if (veri.kilitli) {
          this.$set(this.kalanSureler, item.id, Number(veri.kalan_saniye || 0));
          (this as any).$toast?.info(veri.message || "Henüz aktifleştirilemez.");
          return;
        }

        if (veri.mail_gonderildi) {
          (this as any).$toast?.info(
            "Kullanıcıya davet e-postası gönderildi. Daveti kabul ettiğinde sisteme erişebilecek."
          );
        } else {
          (this as any).$toast?.success("Kullanıcı yeniden aktifleştirildi.");
        }
        // Hem ana personel listesini hem pasif listesini tazele
        this.$emit("load");
        this.load();
      })
      .catch((e: any) => {
        const veri = e?.response?.data?.data ?? e?.response?.data ?? {};
        // Sunucu büro seçimi istiyorsa (422) pencereyi aç.
        if (veri.kod === "buro_secimi_gerekli") {
          this.buroSecimiAc(item);
          return;
        }
        (this as any).$toast?.error(veri.message || "İşlem tamamlanamadı.");
      })
      .finally(() => {
        this.activatingId = null;
      });
  }
}
